import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { withStyles } from '@material-ui/styles';
import {
  HOUR_MINUTE_DAY_TIME,
  MILITARY_TIME
} from 'bento-ordering/base/constants/timeFormat';
const NO_HOURS_MESSAGE = 'Currently Unavailable';

const styles = {
  root: {
    lineHeight: 1.3
  }
};
const HoursDay = ({ label, hours, adornmentEnd, classes, dataTestId }) => {
  const formattedHours = (hours || []).map((hours, idx, arr) => (
    <ListItem
      role="listitem"
      key={`${label}-${hours.open_time}-${hours.close_time}-${idx}`}
    >
      <Typography className={classes.root}>
        {moment(hours.open_time, MILITARY_TIME).format(HOUR_MINUTE_DAY_TIME)} -{' '}
        {moment(hours.close_time, MILITARY_TIME).format(HOUR_MINUTE_DAY_TIME)}
        {idx === arr.length - 1 && adornmentEnd}
      </Typography>
    </ListItem>
  ));

  return (
    <div data-testid={dataTestId}>
      {formattedHours.length ? (
        <div>
          <Typography className={classes.root} component="span">
            {label}
          </Typography>
          : <List>{formattedHours}</List>
        </div>
      ) : (
        <Typography>{`${label}: ${NO_HOURS_MESSAGE}`} </Typography>
      )}
    </div>
  );
};

HoursDay.defaultProps = {
  hours: [],
  dataTestId: ''
};

HoursDay.propTypes = {
  label: PropTypes.string,
  dataTestId: PropTypes.string,
  adornmentEnd: PropTypes.element,
  hours: PropTypes.arrayOf(
    PropTypes.shape({
      open_time: PropTypes.string,
      close_time: PropTypes.string
    })
  ),
  classes: PropTypes.shape({})
};

export default withStyles(styles)(HoursDay);
